import React, { useState } from "react";
import { fmtDateFull, fmtNum } from "../../../shared/utils";

export default function Extrato({
  currentStudent,
  checkpoints,
  checkpointsComAutomaticos,
  bonusLog,
  redemptions,
  transfers,
  batalhas,
  activities,
  goto,
}) {
  const [filtro, setFiltro] = useState("tudo");

  if (!currentStudent) {
    goto("login-aluno");
    return null;
  }
  const aid = Number(currentStudent.id);
  // Inclui os checkpoints automáticos do contador de tempo estudado, senão
  // esses pontos/tokens somem do extrato e do total de pontos atuais.
  const checkpointsBase = Array.isArray(checkpointsComAutomaticos)
    ? checkpointsComAutomaticos
    : Array.isArray(checkpoints)
      ? checkpoints
      : [];
  const movs = [];
  checkpointsBase
    .filter(
      (c) => Number(c.aluno_id) === aid && c.status_questao !== "invalido",
    )
    .forEach((cp) => {
      movs.push({
        id: "cp_" + cp.id,
        data: cp.data_estudo,
        ts: cp.criado_em,
        tipo: "entrada",
        categoria: "checkpoint",
        desc: cp.observacao || "Checkpoint de estudo",
        detalhe: cp.itens
          .map((it) => {
            const a = activities.find(
              (x) => Number(x.id) === Number(it.tipo_id),
            );
            return `${a?.nome}: ${it.quantidade} ${a?.unidade}s`;
          })
          .join(" · "),
        pts: +(cp.pontos_rank || 0),
        tok: +(cp.tokens || 0),
      });
    });
  bonusLog
    .filter((b) => Number(b.aluno_id) === aid)
    .forEach((b) => {
      const ehBonus = (b.pontos_rank || 0) >= 0 && (b.tokens || 0) >= 0;
      movs.push({
        id: "bon_" + b.id,
        data: b.data,
        ts: 0,
        tipo: ehBonus ? "entrada" : "saida",
        categoria: ehBonus ? "bonus" : "penalidade",
        desc: b.motivo || (ehBonus ? "Bônus" : "Penalidade"),
        detalhe: "",
        pts: Number(b.pontos_rank || 0),
        tok: Number(b.tokens || 0),
      });
    });
  transfers
    .filter((t) => Number(t.para) === aid)
    .forEach((t) =>
      movs.push({
        id: "trec_" + t.id,
        data: t.data,
        ts: 0,
        tipo: "entrada",
        categoria: "transferencia",
        desc: t.motivo || "Tokens recebidos",
        detalhe: "",
        pts: 0,
        tok: Number(t.tokens || 0),
      }),
    );
  transfers
    .filter((t) => Number(t.de) === aid)
    .forEach((t) =>
      movs.push({
        id: "tenv_" + t.id,
        data: t.data,
        ts: 0,
        tipo: "saida",
        categoria: "transferencia",
        desc: t.motivo || "Tokens enviados",
        detalhe: "",
        pts: 0,
        tok: -Number(t.tokens || 0),
      }),
    );
  redemptions
    .filter((r) => Number(r.aluno_id) === aid && r.status !== "cancelado")
    .forEach((r) =>
      movs.push({
        id: "red_" + r.id,
        data: r.data,
        ts: 0,
        tipo: "saida",
        categoria: "loja",
        desc: r.item_nome || "Resgate na loja",
        detalhe: r.status === "aprovado" ? "Aprovado" : "Aguardando",
        pts: 0,
        tok: -Number(r.pontos || 0),
      }),
    );
  batalhas
    .filter(
      (b) =>
        (b.status === "finalizada" || b.status === "empate") &&
        (Number(b.desafiante_id) === aid || Number(b.desafiado_id) === aid),
    )
    .forEach((b) => {
      const venci = Number(b.vencedor_id) === aid;
      const emp = b.status === "empate";
      movs.push({
        id: "bat_" + b.id,
        data: b.data_fim,
        ts: 0,
        tipo: emp ? "neutro" : venci ? "entrada" : "saida",
        categoria: "desafio",
        desc: `Desafio: ${b.criterio_label || ""}`,
        detalhe: emp ? "Empate" : venci ? "Vitória" : "Derrota",
        pts: 0,
        tok: emp ? 0 : venci ? Number(b.aposta || 0) : -Number(b.aposta || 0),
      });
    });
  movs.sort((a, b) => b.data.localeCompare(a.data) || b.ts - a.ts);
  const filtrados = movs.filter((m) => {
    if (filtro === "entrada") return m.tipo === "entrada";
    if (filtro === "saida") return m.tipo === "saida";
    if (filtro === "tokens") return m.tok !== 0;
    if (filtro === "pontos") return m.pts !== 0;
    return true;
  });
  const totalPtsRanking = checkpointsBase
    .filter(
      (c) => Number(c.aluno_id) === aid && c.status_questao !== "invalido",
    )
    .reduce((s, c) => s + Number(c.pontos_rank || 0), 0);
  const totalTokDisp = movs.reduce((s, m) => s + Number(m.tok || 0), 0);
  const catIcon = {
    checkpoint: (
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    ),
    bonus: (
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      >
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    ),
    penalidade: (
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      >
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    ),
    transferencia: (
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      >
        <line x1="22" y1="2" x2="11" y2="13" />
        <polygon points="22 2 15 22 11 13 2 9 22 2" />
      </svg>
    ),
    loja: (
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      >
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
      </svg>
    ),
    desafio: (
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      >
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
      </svg>
    ),
  };
  const catCor = {
    checkpoint: "#4FB3A9",
    bonus: "#4FB3A9",
    penalidade: "#D9534F",
    transferencia: "#8B5CF6",
    loja: "#F59E0B",
    desafio: "#FF8C42",
  };

  return (
    <div className="cn">
      <h1 className="pt">
        <em>Extrato</em>
      </h1>
      <div className="ps">Todas as entradas e saídas de pontos e tokens</div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 8,
          marginBottom: 14,
        }}
      >
        <div
          style={{
            background: "#FFF",
            borderRadius: 12,
            padding: "12px 13px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
            borderTop: "3px solid #FF8C42",
          }}
        >
          <div
            style={{
              fontSize: 9,
              color: "#6B8590",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: ".1em",
              marginBottom: 4,
            }}
          >
            Pontos Atuais
          </div>
          <div
            style={{
              fontSize: 22,
              fontWeight: 800,
              color: totalPtsRanking >= 0 ? "#FF8C42" : "#D9534F",
            }}
          >
            {fmtNum(totalPtsRanking, 2)}
          </div>
        </div>
        <div
          style={{
            background: "#FFF",
            borderRadius: 12,
            padding: "12px 13px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
            borderTop: "3px solid #4FB3A9",
          }}
        >
          <div
            style={{
              fontSize: 9,
              color: "#6B8590",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: ".1em",
              marginBottom: 4,
            }}
          >
            Tokens Disponíveis
          </div>
          <div style={{ fontSize: 22, fontWeight: 800, color: "#4FB3A9" }}>
            {fmtNum(Math.max(0, totalTokDisp), 2)}
          </div>
        </div>
      </div>
      <div className="tabs" style={{ marginBottom: 12 }}>
        {[
          ["tudo", "Tudo"],
          ["entrada", "Entradas"],
          ["saida", "Saídas"],
          ["tokens", "Tokens"],
          ["pontos", "Pontos"],
        ].map(([v, l]) => (
          <button
            key={v}
            className={filtro === v ? "a" : ""}
            onClick={() => setFiltro(v)}
            style={{ fontSize: 11 }}
          >
            {l}
          </button>
        ))}
      </div>
      {filtrados.length === 0 ? (
        <div className="es">
          <h3>Nenhuma movimentação</h3>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          {filtrados.map((m) => {
            const cor = catCor[m.categoria] || "#6B8590";
            return (
              <div
                key={m.id}
                style={{
                  background: "#FFF",
                  borderRadius: 12,
                  padding: "11px 13px",
                  boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
                  borderLeft: `3px solid ${cor}`,
                  display: "flex",
                  alignItems: "center",
                  gap: 11,
                }}
              >
                <div
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    background: `${cor}15`,
                    color: cor,
                    display: "grid",
                    placeItems: "center",
                    flexShrink: 0,
                  }}
                >
                  {catIcon[m.categoria]}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: "#1F4754",
                      lineHeight: 1.2,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {m.desc}
                  </div>
                  <div style={{ fontSize: 10, color: "#B8C5CC", marginTop: 2 }}>
                    {fmtDateFull(m.data)}
                    {m.detalhe && ` · ${m.detalhe}`}
                  </div>
                </div>
                <div style={{ textAlign: "right", flexShrink: 0 }}>
                  {m.pts !== 0 && (
                    <div
                      style={{
                        fontSize: 14,
                        fontWeight: 800,
                        color: m.pts > 0 ? "#FF8C42" : "#D9534F",
                        lineHeight: 1,
                      }}
                    >
                      {m.pts > 0 ? "+" : ""}
                      {fmtNum(m.pts, 2)}
                      <span
                        style={{
                          fontSize: 8,
                          marginLeft: 2,
                          color: "#B8C5CC",
                          fontWeight: 600,
                        }}
                      >
                        pts
                      </span>
                    </div>
                  )}
                  {m.tok !== 0 && (
                    <div
                      style={{
                        fontSize: 13,
                        fontWeight: 700,
                        color: m.tok > 0 ? "#4FB3A9" : "#D9534F",
                        marginTop: m.pts !== 0 ? 2 : 0,
                        lineHeight: 1,
                      }}
                    >
                      {m.tok > 0 ? "+" : ""}
                      {fmtNum(m.tok, 2)}
                      <span
                        style={{
                          fontSize: 8,
                          marginLeft: 2,
                          color: "#B8C5CC",
                          fontWeight: 600,
                        }}
                      >
                        tok
                      </span>
                    </div>
                  )}
                  {m.tipo === "neutro" && m.tok === 0 && (
                    <div
                      style={{
                        fontSize: 11,
                        color: "#F59E0B",
                        fontWeight: 700,
                      }}
                    >
                      Empate
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
      <p style={{ marginTop: 16 }}>
        <button className="btn bg bs" onClick={() => goto("perfil")}>
          Voltar ao perfil
        </button>
      </p>
    </div>
  );
}
